import type * as Schema from 'src/types/graphql';

import type { RightToWork } from './types';

export const mapRightsToWorkIntoInputs = (
  rightsToWork: RightToWork[],
): Schema.UpdateRightToWorkInput[] =>
  rightsToWork.map(({ id, country: { countryCode }, type2 }) => ({
    id,
    countryCode,
    type2: type2?.id
      ? {
          id: type2?.id,
        }
      : null,
  }));

export const mergeExistingRightsToWorkWithInput = (
  currentRightsToWork: Schema.UpdateRightToWorkInput[],
  updateRightToWorkInput: Schema.UpdateRightToWorkInput,
): Schema.UpdateRightToWorkInput[] =>
  currentRightsToWork.map((right) =>
    updateRightToWorkInput.id === right.id
      ? updateRightToWorkInput
      : {
          id: right.id,
          countryCode: right.countryCode,
          type2: right.type2?.id
            ? {
                id: right.type2?.id,
              }
            : null,
        },
  );
